{
  "data": "",
  "corporatePortal": {
    "data": {
      "title": "Yrityksesi matkustusdata",
      "description": "Valitse päivämäärät katsoaksesi yrityksesi matkustustietoja. Hinnoissa on mukana lennot, lentokenttämaksut, verot ja soveltuvat palvelumaksut.",
      "error": "Datan latauksessa tapahtui virhe. Yritäthän myöhemmin uudestaan.",
      "empty": "Yritykselläsi ei ole liikematkoja. Kun joku tiimistäsi matkustaa, tiedot näkyvät tässä.",
      "aria": {
        "chart": "Näytä koko kaavio",
        "table": "Näytä koko taulukko",
        "lastYear": "Valitse aikasuodatin: Edelliset 12 kuukautta",
        "yearToDate": "Valitse aikasuodatin: Kuluvan vuoden alusta tähän päivään",
        "lastSixMonths": "Valitse aikasuodatin: Edelliset 6 kuukautta"
      },
      "filter": {
        "lastYear": "Edelliset 12 kuukautta",
        "yearToDate": "Kuluva vuosi",
        "lastSixMonths": "Edelliset 6 kuukautta"
      },
      "units": {
        "currency": "€",
        "co2": "Tonnia",
        "passengers": "matkustajaa"
      },
      "kpi": {
        "totalSpend": "Yhteensä",
        "totalTrips": "Varausten kokonaismäärä",
        "totalPassengers": "Matkustajien kokonaismäärä",
        "coEmissions": "CO2-päästöt tonneissa"
      },
      "charts": {
        "topTenTrips": {
          "title": "Top 10 reitit"
        },
        "ticketTypes": {
          "title": "Lipputyypit"
        },
        "passengers": {
          "title": "Matkustajien lukumäärä"
        },
        "trips": {
          "title": "Matkojen lukumäärä"
        }
      },
      "tables": {
        "month": "Kuukausi",
        "trip": "Reitti",
        "ticketType": "Lipputyyppi"
      }
    }
  }
}
